<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
        <el-button
          icon="el-icon-plus"
          type="primary"
          @click="handleEdit(edit, null)"
        >
          新增房价码
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="" class="pr-10">
            <el-select v-model="queryForm.branchId" clearable placeholder="分店">
              <el-option
                v-for="item in branchList"
                :key="item.branchId"
                :label="item.title"
                :value="item.branchId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" class="pr-10">
            <el-select v-model="queryForm.typehood" placeholder="协议类型">
              <el-option
                v-for="item in typehoodList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" class="pr-10">
            <el-select v-model="queryForm.step" placeholder="状态">
              <el-option
                v-for="item in stepList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="关键词(匹配标题)"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="门店"
        prop="branch.title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="酒店"
        prop="hotel.title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="标题别名"
        prop="basic.aliasTitle"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="类型"
        prop="title"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <el-tag>{{ row.typehood == 1 ? '个人' : '协议公司' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="left" label="状态">
        <template #default="{ row }">
          <el-tag>{{ row.step == 1 ? '未上架' : '已上架' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="备注"
        prop="basic.text"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleEdit(edit, row)">
            编辑
          </el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { removeRateCode, findRateCodeList } from '@/api/room'
import { getAllBranchs } from '@/api/branch'
import Edit from './edit.vue'
import { reactive, ref, getCurrentInstance } from 'vue'

export default {
  name: 'RoomTypeCodeIndex',
  components: { Edit },
  setup() {
    const { proxy } = getCurrentInstance()
    const list = reactive([])
    const branchList = reactive([])
    const stepList = [
      {
        label: '未上架',
        value: 1,
      },
      {
        label: '已上架',
        value: 2,
      },
    ]
    const typehoodList = [
      {
        label: '个人',
        value: 1,
      },
      {
        label: '协议公司',
        value: 2,
      },
    ]
    const listLoading = ref(true)
    const layout = 'total, sizes, prev, pager, next, jumper'
    const total = ref(0)
    const queryForm = reactive({
      page: 1,
      size: 10,
      branchId: '',
      typehood: '',
      step: '',
      keyword: '',
    })
    const edit = ref(null)
    const fetchData = async () => {
      listLoading.value = true
      const { list: list1, total: total1 } = await findRateCodeList(queryForm)
      list.length = 0
      list.push(...list1)
      total.value = total1
      listLoading.value = false
    }
    const queryData = () => {
      queryForm.page = 1
      fetchData()
    }
    const getAllBranchList = async () => {
      const res = await getAllBranchs({})
      if (!res) return
      branchList.length = 0
      branchList.push(...res)
    }
    //添加和编辑
    const handleEdit = (edit, row) => {
      edit.showEdit(row)
    }
    const handleDelete = (row) => {
      proxy.$baseConfirm(
        `你确定要删除房价码：${row.title} 吗`,
        null,
        async () => {
          await removeRateCode({ rateCodeId: row.rateCodeId })
          proxy.$baseMessage(
            `删除房价码成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
          queryData()
        }
      )
    }
    //分页
    const handleSizeChange = (val) => {
      queryForm.size = val
      fetchData()
    }
    const handleCurrentChange = (val) => {
      queryForm.page = val
      fetchData()
    }
    getAllBranchList()
    //拉取数据
    queryData()
    return {
      list,
      listLoading,
      layout,
      total,
      queryForm,
      moment,
      edit,
      typehoodList,
      stepList,
      branchList,
      fetchData,
      queryData,
      handleEdit,
      handleDelete,
      handleSizeChange,
      handleCurrentChange,
    }
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
